import styled, { css } from 'styled-components'

export const InputStyled = styled.input`
  display: block;
  padding: 10px 20px;
  border: 2px solid ${(props) => props.pink ? props.theme.veryLightPink : props.theme.grassyGreen50};
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.greyishBrown};
  border-radius: 6px;
  transition: border .15s;
  ::placeholder {
    color: ${({ theme }) => theme.lightPeach};
  }
  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `
  };
  ${({ name }) =>
    name === "search" &&
    css`
      border: 2px solid ${({ theme }) => theme.green};
      border-radius: 4px;
    `
  };
    
`
export const InputError = styled.div`
  color: ${({ theme }) => theme.pastelRed};
  font-size: 12px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-top: 5px;
  margin-bottom: 5px;
  height: 15px;
  opacity: 0;
  transition: opacity .15s;
`

export const InputWrapper = styled.div`
  margin-bottom: 20px;
  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `
  };
  ${({ noMargin }) =>
    noMargin &&
    css`
      margin: 0;
    `
  };
  ${({ error }) =>
    error &&
    css`
      ${InputStyled} {
        border: 2px solid ${({ theme }) => theme.pastelRed};
      }
      ${InputError} {
        opacity: 1;
      }
    `
  }
`